<template>
<div class="matter-view" @mousedown="mDown" @mouseup="mUp" tabindex="1" @blur="setBlur">
  <div id="testLabel" @click="$router.back()">돌아가기</div>
  <div id="canvas-test" ></div>
<!--  <div class="control">-->
<!--    <span class="control-button play-button" v-if="!shooting" @click="playAction"><i class="fas fa-play"></i></span>-->
<!--    <span class="control-button pause-button" v-else @click="setBlur"><i class="fas fa-pause"></i></span>-->
<!--  </div>-->
</div>
</template>

<script>
import {
  Engine,
  Render,
  World,
  Bodies,
  // Body,
  Events,
  // Composite,
  // Composites,
  // Constraint,
  Vertices,
  Mouse,
  MouseConstraint,
  // Query,
  Common,
  Runner,
} from 'matter-js';
import decomp from 'poly-decomp';

export default {
  name: 'matter-view',
  data() {
    return {
      engine: null,
      shoot: null,
      shooting: false,
      canvasProp: {
        wallWidth: 1,
      },
      size: 3,
      pathArray: [
        '0 0 50 0 50 50 40 50 40 10 0 10 0 0', // ㄱ
        '0 0 10 0 10 40 50 40 50 50 0 50 0 0', // ㄴ
        '0 0 50 0 50 10 10 10 10 40 50 40 50 50 0 50 0 0', // ㄷ
        '0 0 50 0 50 30 10 30 10 40 50 40 50 50 0 50 0 20 40 20 40 10 0 10 0 0', // ㄹ
        '0 0 50 0 50 50 40 50 40 10 10 10 10 40 39.9 40 39.9 50 0 50 0 0', // ㅁ
        '0 0 10 0 10 10 40 10 40 0 50 0 50 50 40 50 40 20 10 20 10 40 39.9 40 39.9 50 0 50 0 0', // ㅂ
        '20 0 30 0 50 50 40 50 25 15 10 50 0 50 20 0', //  ㅅ
        '0 0 0 50 10 50 10 30 50 30 50 20 10 20 10 10 50 10 50 0 0 0', // ㅋ
      ],
      pathList: [
        'L0 0 50 0 50 50 40 50 40 10 0 10 0 0', // ㄱ
        'L0 0 10 0 10 40 50 40 50 50 0 50 0 0', // ㄴ
        'L0 0 50 0 50 10 10 10 10 40 50 40 50 50 0 50 0 0', // ㄷ
        'L0 0 50 0 50 30 10 30 10 40 50 40 50 50 0 50 0 20 40 20 40 10 0 10 0 0', // ㄹ
        'L0 0 50 0 50 50 40 50 40 10 10 10 10 40 39.9 40 39.9 50 0 50 0 0', // ㅁ
        'L0 0 10 0 10 10 40 10 40 0 50 0 50 50 40 50 40 20 10 20 10 40 39.9 40 39.9 50 0 50 0 0', // ㅂ
        'L20 0 30 0 50 50 40 50 25 15 10 50 0 50 20 0', //  ㅅ
        // 'L25 0A1 1 0 0025 50 1 1 0 0025 0L25 10A1 1 0 0125 40 1 1 0 0125 10M25 10 25 0', // ㅇ
        'L0 0 0 250 50 250 50 150 250 150 250 100 50 100 50 50 250 50 250 0 0 0', // ㅋ
      ],
    };
  },
  created() {
  },
  mounted() {
    window.decomp = decomp;
    const width = window.innerWidth;
    const height = window.innerHeight - 55;
    const engineOptions = {
      enableSleeping: false,
      timing: {
        // timestamp: 0.5,
        timeScale: 0.5,
      },
    };
    const renderOptions = {
      width,
      height,
      wireframes: false,
      wireframeBackground: 'transparent',
      background: 'transparent',
      // background: "#ffffff99",
      showSleeping: true,
      showDebug: false,
      showBroadphase: false,
      showBounds: false,
      showVelocity: false,
      showCollisions: false,
      showSeparations: false,
      showAxes: false,
      showPositions: false,
      showAngleIndicator: false,
      showIds: false,
      showShadows: false,
      showVertexNumbers: false,
      showConvexHulls: false,
      showInternalEdges: false,
      showMousePosition: true,
    };
    // const engine = Engine.create(engineOptions);
    this.engine = Engine.create(engineOptions);
    const { world } = this.engine;

    this.engine.world.gravity.y = 1;
    // const size = 20;
    // create a renderer
    const render = Render.create({
      element: document.getElementById('canvas-test'),
      engine: this.engine,
      options: renderOptions,
    });

    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(this.engine, {
      mouse,
      constraint: {
        stiffness: 0.5,
        render: {
          visible: true,
        },
      },
    });

    World.add(world, mouseConstraint);
    render.mouse = mouse;

    let fsa = [];
    Events.on(mouseConstraint, 'startdrag', (event) => {
      fsa = event.body.parts.map((v) => v.render.fillStyle);
      event.body.parts = event.body.parts.map((v) => {
        v.render.fillStyle = '#FF0000';
        return v;
      });
    });

    Events.on(mouseConstraint, 'enddrag', (event) => {
      // eslint-disable-next-line no-return-assign
      event.body.parts.map((v, i) => (event.body.parts[i].render.fillStyle = fsa[i]));
    });

    // const fPath = Vertices.fromPath('M384 334.2C384 351.87 369.67 366.2 352 366.2H320V447.98C320 465.65 305.67 479.98 288 479.98S256 465.65 256 447.98V366.2H32C21.03 366.2 10.83 360.575 4.95 351.31-.909 342.044-1.612 330.42 3.075 320.5L131.075 50.3C138.6 34.33 157.8 27.56 173.7 35.09 189.67 42.652 196.48 61.75 188.92 77.72L82.56 302.2H256V160C256 142.33 270.33 128 288 128S320 142.33 320 160V302.2H352C369.7 302.2 384 316.6 384 334.2Z');
    // const fPath = Vertices.fromPath(`L${this.pathArray[0]}`);
    // const stack = Bodies.fromVertices(
    //   width / 2,
    //   height / 2,
    //   fPath,
    //   {
    //     friction: 0.5,
    //     restitution: 0.8,
    //     render: {
    //       fillStyle: '#0a0a0a',
    //       strokeStyle: 'transparent',
    //       lineWidth: 0,
    //     },
    //   },
    //   true,
    // );

    // const circle = Bodies.circle(width / 2, 50, 20, {
    //   friction: 0.5,
    //   // 단어 그대로 마찰력 값입니다. (0~1)
    //   restitution: 0.8,
    //   // 단어 그대로 복원력 입니다. (0~1)
    //   render: {
    //     fillStyle: '#000',
    //     strokeStyle: '#000',
    //     lineWidth: 1,
    //   },
    //   // fillStyle 은 채워질 색, strokeStyle은 선색, lineWidth 선 굵기
    // });

    const ground = Bodies.rectangle(width / 2, height, width, 5, {
      isStatic: true,
      friction: 0.2,
      // angle: Math.PI * 0.09,
      // 고정된 위치의 오브제
    });
    const wallL = Bodies.rectangle(0, height, 5, height, {
      isStatic: true,
      friction: 1,
      // 고정된 위치의 오브제
    });
    const wallR = Bodies.rectangle(width, height, 5, height, {
      isStatic: true,
      friction: 1,
      // 고정된 위치의 오브제
    });

    // Add Walls
    const topWall = Bodies.rectangle(width / 2, this.canvasProp.wallWidth, width, this.canvasProp.wallWidth, { isStatic: true });
    // const wallL = Bodies.rectangle(this.canvasProp.wallWidth, height / 2, this.canvasProp.wallWidth, height, { isStatic: true });
    // const wallR = Bodies.rectangle(width - this.canvasProp.wallWidth, height / 2, this.canvasProp.wallWidth, height, { isStatic: true });
    //
    // const ground = Bodies.rectangle(width / 2, height - this.canvasProp.wallWidth, width, this.canvasProp.wallWidth, { isStatic: true });
    World.add(world, [wallL, wallR, topWall, ground]);

    // Moving Stick
    // const boxA = Bodies.rectangle(width / 2, height / 2, width / 4, 16, {
    //   isStatic: false,
    // });
    // Body.setAngularVelocity(boxA, Math.PI / 18);
    // Body.setVelocity(boxA, { x: -10, y: -10 });
    // // Static Objects
    // const boxB = Bodies.rectangle(
    //   Math.random() * width,
    //   Math.random() * height,
    //   80,
    //   80,
    //   { isStatic: true },
    // );
    // const ball = Bodies.circle(
    //   Math.random() * width,
    //   Math.random() * height,
    //   40,
    //   { isStatic: true },
    // );
    // // add all of the bodies to the world
    // Events.on(boxA, 'sleepEnd', (e) => console.log(e));
    // World.add(world, [boxA, boxB, ball]);
    //
    // const boxes = Composites.stack(
    //   width / 2,
    //   height / 2,
    //   1,
    //   4,
    //   0,
    //   0.78,
    //   (x, y) => Bodies.circle(x, y, 16, { dampening: 1 }),
    // );
    // const chain = Composites.chain(boxes, 0, 0, 0.1, 0.1, {
    //   dampening: 1,
    //   stiffness: 1,
    //   render: { strokeStyle: 'transparent', lineWidth: 0 },
    // });
    // Composite.add(
    //   boxes,
    //   Constraint.create({
    //     pointA: { x: width / 4, y: height / 2 },
    //     bodyB: boxes.bodies[3],
    //     length: 1,
    //     stiffness: 1,
    //     dampening: 1,
    //     render: {
    //       strokeStyle: 'transparent',
    //       type: 'line',
    //     },
    //   }),
    // );
    // World.add(world, chain);

    // const jfPath = Vertices.fromPath(
    //   // 'L0 0 100 0 100 20 60 20 60 40 90 40 90 60 60 60 60 100 40 100 20 100 20 80 40 80 40 20 0 20',
    //   this.pathList[5],
    // );
    // const jfColor = Common.choose(['#556270', '#4ECDC4', '#C7F464', '#FF6B6B', '#C44D58']);
    // const jf = Bodies.fromVertices(
    //   width / 2,
    //   height / 2,
    //   jfPath,
    //   // Common.choose([jfPath]),
    //   {
    //     friction: 0.5,
    //     restitution: 0.8,
    //     render: {
    //       fillStyle: jfColor,
    //       strokeStyle: 'transparent',
    //       lineWidth: 0,
    //     },
    //   },
    //   true,
    // );
    // const jfConstraint = Constraint.create({
    //   pointA: { x: width / 2, y: height / 4 },
    //   bodyB: jf,
    //   pointB: { x: 0, y: -20 },
    //   stiffness: 1,
    //   damping: 0.99,
    //   // length:10,
    //   render: {
    //     // strokeStyle: "transparent",
    //     strokeStyle: jfColor,
    //     type: 'line',
    //     anchors: true,
    //     visible: true,
    //   },
    // });
    // World.add(world, [jf, jfConstraint]);
    Runner.run(this.engine);
    Render.run(render);

    // this.playAction();
    setInterval(() => {
      const k = this.addObject();
      World.add(world, k);
    }, 5000);
  },
  methods: {
    addObject(e) {
      let cx = window.innerWidth / 2;
      let cy = window.innerHeight / 2;
      if (e) {
        cx = e.offsetX;
        cy = e.offsetY;
      }
      const kPath = this.pathArray.map((item) => {
        const sz = (10 % (Math.random() * 5)) + 1;
        const char = item.split(' ').map((ch) => Number(ch) * sz).join(' ');
        return Vertices.fromPath(`L${char}`);
      });
      // const kColor = Common.choose(['#44B4E6', '#72CE16', '#FF9F64', '#F2D328', '#B080FD', '#FC64F3', '#0A0A0A']);
      const kColor = Common.choose(['#0A0A0A']);
      const k = Bodies.fromVertices(
        cx,
        cy,
        Common.choose(kPath),
        {
          friction: 0.5,
          restitution: 0.9,
          render: {
            fillStyle: kColor,
            strokeStyle: 'transparent',
            lineWidth: 0,
          },
        },
        true,
      );
      return k;
    },
    setBlur() {
      this.shooting = false;
      clearInterval(this.shoot);
    },
    playAction() {
      this.shooting = true;
      this.shoot = setInterval(() => {
        // 가로 중앙, 상단에서 50px 떨어진 곳에 반지름이 10인 원을 만들어서
        this.addObject();
      }, 500);
    },
    mDown() {
      this.engine.world.gravity.y = -1;
    },
    mUp() {
      this.engine.world.gravity.y = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  display: none;
}
.control {
  span {
    font-size: 140px;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate( -50%, -50%);
    color: #fff;
  }
}
</style>
